import React from 'react'
import Redirect from '#src/components/Redirect'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import {
  StandaloneRegisterComponent,
  RegisterCustomerInput,
  RegisterCustomerErrorCode,
  StandaloneRegisterComponentProps
} from '#src/generated/graphql'
import { loginLocation } from '#src/services/routing'

interface StandaloneRegisterProps extends RouteComponentProps<any> {
  onCompleted: () => void
  children: StandaloneRegisterComponentProps['children']
  handleRegistrationErrors: (errors: string) => void
  input: RegisterCustomerInput
}

interface StandaloneRegisterState {
  redirect?: string
}

class StandaloneRegister extends React.Component<StandaloneRegisterProps, StandaloneRegisterState> {
  state = { redirect: '' }

  public render() {
    const { children, handleRegistrationErrors, input, location } = this.props

    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }

    return (
      <StandaloneRegisterComponent
        onCompleted={({ registerCustomer }) => {
          if (registerCustomer.user) {
            this.props.onCompleted()
          } else if (registerCustomer.errors) {
            const errorCodes = registerCustomer.errorCodes

            /**
             * If the user is already registered, redirect them to the login page with
             * a custom header shown
             */
            if (errorCodes.includes(RegisterCustomerErrorCode.ALREADY_REGISTERED)) {
              const redirectSearchParams = new URLSearchParams(location.search)
              redirectSearchParams.append('signinLoginReturn', 'true')

              const postLoginLocation = loginLocation(
                {
                  ...location,
                  search: redirectSearchParams.toString()
                },
                { header: 'ALREADY_REGISTERED' }
              )

              this.setState({
                redirect: postLoginLocation.pathname + postLoginLocation.search
              })
            } else {
              const errors = registerCustomer.errors.join(', ')
              handleRegistrationErrors(errors)
            }
          } else {
            throw new Error('Unrecognized response on mutation in standalone registration')
          }
        }}
        onError={error => {
          handleRegistrationErrors(error.message.toString())
        }}
        variables={{
          input
        }}
        children={children}
      />
    )
  }
}

export default withRouter(StandaloneRegister)
